import React from "react";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NotifySkliton = () => {
  return (
    <>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <div className="container my-2">
            
          <div className="d-flex mb-3 ">
            <div className="col-md-1">
              <Skeleton
                className="mt-0 "
                width={60}
                height={60}
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="col-md-11">
              <Skeleton className="mt-0 ms-2 MTS1" height={60} />
            </div>
          </div>

        </div>
      </SkeletonTheme>
    </>
  );
};

export default NotifySkliton;
